import dateFormat from 'dateformat'
import _ from 'lodash'

function install (Vue) {
  simpleDate(Vue)
  simpleDateEn(Vue)
  fullDate(Vue)
  fullDateEn(Vue)
  countdown(Vue)
  hideExtension(Vue)
  fileSize(Vue)
  simpleDateTime(Vue)
  simpleDateTimeEn(Vue)
  fixedFloat(Vue)
  fixedFloat2(Vue)
  bigNumber(Vue)
  bigNumberEn(Vue)
  duration(Vue)
  durationEn(Vue)
  relativeDate(Vue)
  relativeDateEn(Vue)
  hideName(Vue)
  hideNameEn(Vue)
}

function hideName (Vue) {
  Vue.filter('hide_name', function(name) {
    return name ? name.replace(/.$/, '*') : '匿名'
  })
}

function hideNameEn (Vue) {
  Vue.filter('hide_name_en', function(name) {
    return name ? name.replace(/.$/, '*') : 'SomeOne'
  })
}

function hideExtension (Vue) {
  Vue.filter('hide_extension', function(filename) {
    return filename.substr(0, filename.lastIndexOf('.'))
  })
}

function duration (Vue) {
  Vue.filter('duration', function(time) {
    if (!time) return ''
    if (time > 86400000) {
      return ~~(time / 86400000) + ' 天' +
             (~~(time % 86400000 / 3600000) !== 0 ? ' ' + ~~(time % 86400000 / 3600000) + ' 小时' : '')
    }

    if (time > 3600000) {
      return ~~(time / 3600000) + ' 小时 ' +
             (~~(time % 3600000 / 60000) !== 0 ? ' ' + ~~(time % 3600000 / 60000) + ' 分钟' : '')
    }

    if (time > 60000) {
      return ~~(time / 60000) + ' 分钟'
    }

    return ~~(time / 1000) + ' 秒'
  })
}

function durationEn (Vue) {
  Vue.filter('duration_en', function(time) {
    if (!time) return ''
    if (time > 86400000) {
      return ~~(time / 86400000) + ' days' +
             (~~(time % 86400000 / 3600000) !== 0 ? ' ' + ~~(time % 86400000 / 3600000) + ' hours' : '')
    }

    if (time > 3600000) {
      return ~~(time / 3600000) + ' hours ' +
             (~~(time % 3600000 / 60000) !== 0 ? ' ' + ~~(time % 3600000 / 60000) + ' minutes' : '')
    }

    if (time > 60000) {
      return ~~(time / 60000) + ' minutes'
    }

    return ~~(time / 1000) + ' seconds'
  })
}

function countdown (Vue) {
  Vue.filter('countdown', function(sec) {
    if (sec < 0) {
      return '00 : 00'
    }
    if (typeof sec === 'string') return sec
    let min = parseInt(sec / 60)
    let second = parseInt(sec - min * 60)
    if (min < 10) min = '0' + min
    if (second < 10) second = '0' + second
    return min + ' : ' + second
  })
}

function fileSize (Vue) {
  Vue.filter('file_size', function(value) {
    value = parseInt(value)
    if (value > 1024 * 1024) {
      return (value / 1024.0 / 1024.0).toFixed(1) + ' MB'
    } else if (value > 1024) {
      return (value / 1024.0).toFixed(1) + ' KB'
    } else {
      return value + ' Bytes'
    }
  })
}

function simpleDate (Vue) {
  Vue.filter('simple_date', function(value) {
    if (value) {
      const now = new Date()
      value = new Date(value)
      if (value.getFullYear() === now.getFullYear()) {
        return dateFormat(value, 'm月d日')
      }
      return dateFormat(value, 'yy年m月d日')
    }
    return ''
  })
}

function simpleDateEn (Vue) {
  Vue.filter('simple_date_en', function(value) {
    if (value) {
      const now = new Date()
      value = new Date(value)
      if (value.getFullYear() === now.getFullYear()) {
        return dateFormat(value, 'mmmm dS')
      }
      return dateFormat(value, 'mmmm dS, yyyy')
    }
    return ''
  })
}

function simpleDateTime (Vue) {
  Vue.filter('simple_date_time', function(value) {
    if (value) {
      return dateFormat(new Date(value), 'mm月dd日 HH:MM')
    }
    return ''
  })
}

function simpleDateTimeEn (Vue) {
  Vue.filter('simple_date_time_en', function(value) {
    if (value) {
      return dateFormat(new Date(value), 'mmmm dS, HH:MM')
    }
    return ''
  })
}

function fullDate (Vue) {
  Vue.filter('full_date', function(value) {
    if (value) {
      const date = new Date(value)
      if (date.getTime() >= 0) {
        return dateFormat(date, 'yyyy年mm月dd日 HH:MM')
      }
    }
    return value || ''
  })
}

function fullDateEn (Vue) {
  Vue.filter('full_date_en', function(value) {
    if (value) {
      const date = new Date(value)
      if (date.getTime() >= 0) {
        return dateFormat(date, 'mmmm dS, yyyy, HH:MM')
      }
    }
    return value || ''
  })
}

function fixedFloat (Vue) {
  Vue.filter('fixed', function(value) {
    if (_.isInteger(value)) return value
    if (_.isNumber(value)) return value.toFixed(1)
    return value
  })
}

function fixedFloat2 (Vue) {
  Vue.filter('fixed2', function(value) {
    if (_.isInteger(value)) return value
    if (_.isNumber(value)) return value.toFixed(2)
    return value
  })
}

function padZero (number) {
  return '000'.substring(number.toString().length) + number
}

function bigNumber (Vue) {
  Vue.filter('big_number', function(value) {
    if (!_.isInteger(value)) return value
    if (!value) return 0
    if (value < 1e3) return value
    if (value >= 1e3 && value < 1e5) return ~~(value / 1e3) + ',' + padZero(value % 1000)
    if (value >= 1e5 && value < 1e10) return (value / 1e4).toFixed(1) + ' 万'
  })
}

function bigNumberEn (Vue) {
  Vue.filter('big_number_en', function(value) {
    if (!_.isInteger(value)) return value
    if (!value) return 0
    if (value < 1e3) return value
    if (value >= 1e3 && value < 1e5) return ~~(value / 1e3) + ',' + padZero(value % 1000)
    if (value >= 1e5 && value < 1e10) return (value / 1e3).toFixed(1) + ' K'
  })
}

function relativeDate (Vue) {
  Vue.filter('relative_date', function(date) {
    if (!date) return ''
    if (typeof date === 'string') date = new Date(date)
    const now = new Date()
    const duration = ~~((now.getTime() - date.getTime()) / 1000)
    if (duration >= 0 && duration < 31536000) { // 发表时间不超过1年,可调
      const day = ~~(duration / 86400)
      if (day > 0) {
        // 天数大于31，用月表示
        if (day >= 31) {
          if (now.getFullYear() - date.getFullYear() > 0) return `${now.getMonth() + 12 - date.getMonth()} 个月前`
          else return `${now.getMonth() - date.getMonth()} 个月前`
        }
        // 大于7小于31
        if (day >= 7) return `${~~(day / 7)} 周前`
        // 7天以内
        return `${day} 天前`
      }
      // 小时显示
      const hour = ~~((duration % 86400) / 3600)
      if (hour > 0) return `${hour} 小时前`
      // 分钟显示
      const minute = ~~((duration % 86400 % 3600) / 60)
      if (minute > 0) return `${minute} 分钟前`
      // 秒显示
      const second = ~~(duration % 86400 % 3600 % 60)
      return `${second} 秒前`
    }

    if (date.getFullYear() === now.getFullYear()) {
      return dateFormat(date, 'm月d日')
    }
    return dateFormat(date, 'yyyy年m月d日')
  })
}

function relativeDateEn (Vue) {
  Vue.filter('relative_date_en', function(date) {
    if (!date) return ''
    if (typeof date === 'string') date = new Date(date)
    const now = new Date()
    const duration = ~~((now.getTime() - date.getTime()) / 1000)
    if (duration >= 0 && duration < 31536000) { // 发表时间不超过1年,可调
      const day = ~~(duration / 86400)
      if (day > 0) {
        // 天数大于31，用月表示
        if (day >= 31) {
          if (now.getFullYear() - date.getFullYear() > 0) return `${now.getMonth() + 12 - date.getMonth()} months ago`
          else return `${now.getMonth() - date.getMonth()} months ago`
        }
        // 大于7小于31
        if (day >= 7) return `${~~(day / 7)} weeks ago`
        // 7天以内
        return `${day} days ago`
      }
      // 小时显示
      const hour = ~~((duration % 86400) / 3600)
      if (hour > 0) return `${hour} hours ago`
      // 分钟显示
      const minute = ~~((duration % 86400 % 3600) / 60)
      if (minute > 0) return `${minute} minutes ago`
      // 秒显示
      const second = ~~(duration % 86400 % 3600 % 60)
      return `${second} seconds ago`
    }

    if (date.getFullYear() === now.getFullYear()) {
      return dateFormat(date, 'mmmm dS')
    }
    return dateFormat(date, 'mmmm dS, yyyy')
  })
}

export default install
